import * as yup from "yup";
export const MarketingListSchema = yup.object().shape({
  MarketingList: yup.string().required("Required"),
  MarketingCampaign: yup.string().required("Required"),
  ScheduleDate: yup.string().required("Required"),
  Thresholds: yup.string().required("Required"),
});
